import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, Router } from "@angular/router";
import { AuthFlowService } from "../services/auth-flow/auth-flow.service";

/**
 * Role guard that checks if user has required role for the route
 * 
 * Usage in routes:
 * {
 *   path: 'admin',
 *   component: AdminComponent,
 *   canActivate: [roleGuard],
 *   data: { roles: ['admin'] }  // or data: { roles: ['doctor', 'clinic'] }
 * }
 * 
 * - If user has required role → Allow access
 * - If user doesn't have required role → Redirect to appropriate fallback
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authFlowService = inject(AuthFlowService);
  const router = inject(Router);


  const requiredRoles = route.data?.['roles'] as string[] | undefined;
  const userRole = authFlowService.userRole();


  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  if (!userRole) {
    router.navigate(["/"]);
    return false;
  }

  const hasRequiredRole = requiredRoles.includes(userRole);

  if (!hasRequiredRole) {
    // Redirect based on user role to appropriate section
    const completionRoute = authFlowService.getCompletionRoute();
    router.navigate([completionRoute]);
    return false;
  }

  return true;
};